// contexts/NavigationContext.js
import React, { createContext, useContext, useState } from "react";

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [hasSubmittedVideo, setHasSubmittedVideo] = useState(false);

  return (
    <NavigationContext.Provider
      value={{ hasSubmittedVideo, setHasSubmittedVideo }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
